import { render, staticRenderFns } from "./StockPage.vue?vue&type=template&id=3bd96928"
import script from "./StockPage.vue?vue&type=script&lang=js"
export * from "./StockPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports